<!-- eslint-disable vue/multiline-html-element-content-newline -->
<template>
  <div class="record-comment-input">
    <div class="comment-real-input">
      <x-comment-input
        ref="commentInput"
        v-bind="$attrs"
        :placeholderOptions="placeholderOptions"
        class="text-area-input"
        @onChange="onChange"
      ></x-comment-input>

      <div v-show="attachments.length > 0" class="record-comment-attachments">
        <template v-for="item in attachments">
          <div
            :key="item.id"
            :class="{
              'record-comment-attachment': true,
              'record-comment-attachment-error': item.error
            }"
          >
            <x-svg-icon name="upload-colorless" class="comment-attachment-logo pointer" />
            <p
              mode="origin"
              class="comment-attachment-name"
            >{{ item.fileName }}</p>
            <cube-loading v-if="item.loading" :size="14"></cube-loading>
            <x-svg-icon
              name="close"
              class="comment-attachment-close"
              @click.native="handleDeleteFileClick(item)"
            />
          </div>
        </template>
      </div>
      <div class="comment-operations">
        <div class="comment-more-content">
          <input
            ref="inputFile"
            class="x-uploader-input"
            type="file"
            :accept="accept"
            @change="handleChange"
          >
          <div class="comment-attachment pointer" @click="handleClick">
            <x-svg-icon
              name="upload-colorless"
            />
          </div>
          <div class="comment-select-person pointer" @click="clickAtPeople">
            <x-svg-icon
              name="at-icon"
            />
          </div>
        </div>
        <div class="comment-about-input">
          <span class="input-counter">{{ getInputLength }}/200</span>
          <cube-button
            ref="sendButton"
            type="primary"
            :loading="sendLoading"
            class="send-button"
            @click="doComment"
          ><cube-loading v-if="sendLoading" :size="14"></cube-loading>
            {{ sendLoading ? '' : '发送' }}
          </cube-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { SET_COMP_PAYLOAD, CLEAR_COMPROUTER_STORE } from '@/store/comp-router.store.js'
import apis from '@/api'
import XCommentInput from '@/lib/ui/components/x-comment-inpit/x-comment-input'
import { mapAdapter } from '@/lib/ui/components/form/form-build-action'
import { openCameraUpload } from '@/vender/third-sdk/third-function/get-camera.js'
import { isOnlyWechat } from '@/lib/ui/utils/platform.util.js'
import { wxSdkInit } from '@/vender/third-sdk/wx-sdk.js'
export default {
  components: { XCommentInput },
  inject: ['removeKeepAlive'],
  data() {
    return {
      inputValue: '',
      showRealInput: false,
      tempIndex: 1,
      uploadid: '',
      uploadList: [],
      placeholderOptions: {
        emptyEditorClass: 'is-editor-empty',
        emptyNodeClass: 'is-empty',
        emptyNodeText: '请输入评论',
        showOnlyWhenEditable: true,
        showOnlyCurrent: true
      },
      keyWord: '',
      command: undefined,
      currentRange: undefined,
      wholeContent: '',
      attachments: [],
      uploadConfigs: {
        fileMaxSize: 10
      },
      fileList: [],
      altEnterFlag: false,
      sendLoading: false,
      sendCallback: undefined,
      atPeople: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.authModule.userInfo,
      compPayload: state => state.compRouterModule.compPayload
    }),
    userArray() {
      return this.formValue ? (Array.isArray(this.formValue) ? this.formValue : [this.formValue]) : []
    },
    formDetailData() {
      return this.compPayload[this.compPayloadKey].formData
    },
    getInputLength() {
      // if (this.inputValue.length > 200) {
      //   this.$refs.commentInput.cutFormValue()
      // }
      return this.inputValue.length
    },
    editor() {
      return this.$refs.commentInput && this.$refs.commentInput.getEditor()
    },
    accept() {
      if (this.uploadType instanceof Array) {
        return this.uploadType.reduce((prev, type) => {
          if (type === 'img') {
            prev.push('image/jpeg', 'image/jpg', 'image/png', 'image/gif')
          } else if (type === 'word') {
            prev.push('application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword')
          } else if (type === 'excel') {
            prev.push('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel')
          } else if (type === 'mp4') {
            prev.push('audio/mpeg', 'audio/mp4, video/mp4', 'video/quicktime')
          } else if (type === 'zip') {
            prev.push('application/x-zip-compressed', 'application/zip', '.rar', '.jar', 'application/octet-stream', '.7z', 'application/x-gzip')
          } else if (type === 'pdf') {
            prev.push('application/pdf')
          }
          return prev
        }, []).toString()
      } else {
        return this.uploadType
      }
    }
  },
  activated() {
    if (this.compPayload) {
      this.removeKeepAlive(this.$options.name)
      let compPayload = this.compPayload[this.compPayload.activeKey]
      if (compPayload.callback instanceof Function && compPayload.dirty) {
        // 兼容非表单的情况，后续可以考虑均采用这种方式
        this.$emit('strech')
        // console.log(compPayload)
        this.atPeople = compPayload.value[0]
        // console.log(this.atPeople, 'input')
        this.$refs.commentInput.addAtPeople(this.atPeople)
        // this.goBottom()
        compPayload.value[0].id = ''
        compPayload.value[0].username = ''
        this.atPeople = {}
        console.log(compPayload.value[0])
        setTimeout(() => {
          this.$emit('goBottom')
        }, 500)
        return ''
      }
    }
    return ''
  },
  methods: {
    ...mapAdapter(['postUpload', 'removeUpload', 'getImgSrc']),
    ...mapMutations('compRouterModule', {
      setCompPayload: SET_COMP_PAYLOAD,
      clearCompRoterStore: CLEAR_COMPROUTER_STORE
    }),
    // ===================== // 输入相关
    onChange(input) {
      // console.log(input)

      const temp = document.createElement('div')
      this.wholeContent = temp.innerHTML = input
      this.inputValue = temp.innerText
    },
    clickAtPeople() {
      this.$emit('clickAtPeople')
    },
    doComment() {
      this.sendLoading = true
      this.sendCallback = () => {
        if (
          (this.inputValue && this.wholeContent) ||
          this.attachments.filter((item) => !item.error).length > 0
        ) {
          if (this.getInputLength > 200) {
            this.$message({
              message: '输入内容最多200字',
              type: 'warning'
            })
            return
          }
          const mentions = this.parseMentions()
          const attachmentIds = this.attachments.map((item) => item.id)
          this.$emit('comment', this.wholeContent, mentions, attachmentIds, this.userInfo)
          this.$refs.commentInput.clearContent()
          this.attachments = []
        } else {
          this.$message({
            message: '不可发送空内容',
            type: 'warning'
          })
        }
        this.sendCallback = undefined
        this.sendLoading = false
        this.$refs.sendButton && this.$refs.sendButton.$el.blur()
      }
      this.checkAttachmentUpload()
    },
    checkAttachmentUpload(notSend) {
      let attachmentsAllUploaded = true
      this.attachments.forEach((item) => {
        if (item.loading) {
          attachmentsAllUploaded = false
        }
      })
      if (
        attachmentsAllUploaded &&
        this.sendCallback &&
        this.sendCallback instanceof Function &&
        !notSend
      ) {
        this.sendCallback()
      }
      if (notSend) {
        this.sendLoading = false
      }
    },
    parseMentions() {
      const temp = document.createElement('div')
      temp.innerHTML = this.wholeContent
      const allMentions = temp.querySelectorAll('span.editor-comment-mention')
      return Array.from(
        new Set(
          Array.prototype.slice.call(allMentions).map((ele) => {
            return ele.attributes['id'].value
          })
        )
      )
    },

    // =================== // 上传相关
    handleClick() {
      if (isOnlyWechat() && this.isOnlyImage) {
        this.handleClickUpload()
      } else {
        this.$refs.inputFile && this.$refs.inputFile.click()
      }
    },
    beforeUpload(file) {
      if (this.uploadConfigs.fileMaxSize * 1000000 < file.size) {
        this.$message({
          message: '文件太大，请重新上传',
          type: 'warning'
        })
        return false
      }
      this.handleUpload(file)
      this.attachments.push({
        id: file.id,
        fileName: file.name,
        fileType: 'loading',
        fileSize: '',
        fileSizeStr: '',
        creatorName: '',
        downloadUrl: '',
        creationDate: '',
        loading: true
      })
    },
    handleClickUpload() {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        wxSdkInit('ocr')
        this.$bus.$on(`getOcrInit`, () => {
          setTimeout(() => {
            openCameraUpload().then((data) => {
              this.handleUpload(data.target.files)
            })
          }, 150)
          this.$bus.$off('getOcrInit')
        })
        // this.$refs.fileInput && this.$refs.fileInput.click()
      } else {
        openCameraUpload().then((data) => {
          this.handleUpload(data.target.files)
        })
      }
    },
    postUploadProxy(file) {
      return new Promise((resolve, reject) => {
        this.postUpload(file).then(data => {
          resolve({
            ...data,
            src: this.getImgSrc(data)
          })
          // this.loadingStack.pop()
        }, (err) => {
          reject(err)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getImgSrc(data) {
      if (data) {
        const params = this.$base64.encode(JSON.stringify({
          xdaptenantid: data.tenantId,
          xdaptoken: this.$axios.defaults.headers.xdaptoken
        }))
        return data.url && `${data.url}&token=${params}`
      } else {
        return ''
      }
    },
    handleUploadSuccess(file) {
      this.uploadSuccess(file)
    },
    handleChange(file) {
      // console.log(file)
      this.fileList = file.target.files[0]
      this.fileList.id = this.uploadid
      this.beforeUpload(this.fileList)
    },
    uploadSuccess(data) {
      this.attachments.forEach((item) => {
        if (item.id === data) {
          item.loading = false
        }
      })
    },
    handleUpload(data) {
      data.loading = true
      this.$emit('strech')
      this.uploadFile(data)
        .asyncThen(
          (resp) => {
            console.log(resp)
            if (resp.code === 'ok') {
              this.$nextTick(() => {
                // this.handleError(data.uid)
                this.attachments = this.attachments.map((item, index) => {
                  console.log(item, '数组')
                  if (item.loading && item.id.toString() === resp.data.uploadId) {
                    console.log(item.id)
                    console.log(resp.data.uploadId)
                    return {
                      fileName: resp.data.fileName,
                      fileType: resp.data.fileType,
                      fileSize: resp.data.fileSize,
                      fileSizeStr: resp.data.fileSizeStr,
                      creatorName: resp.data.creatorName,
                      creationDate: resp.data.creationDate,
                      tenantId: resp.data.tenantId,
                      id: resp.data.id,
                      url: resp.data.url,
                      downloadUrl: resp.data.url
                    }
                  } else {
                    return item
                  }
                })
                this.checkAttachmentUpload()
                this.uploadSuccess(resp.data.id)
              })
            } else {
              this.handleError(data.uid)
            }
          },
          (err) => {
            this.handleError(data.uid)
          }
        )
        .asyncErrorCatch((err) => {
          this.handleError(data.uid)
        })
    },

    handleError(id) {
      console.log('上传失败')
      const atta = this.attachments.find((item) => item.id.toString() === id.toString())
      if (atta) {
        atta.loading = false
        atta.error = true
      }
      this.checkAttachmentUpload(true)
    },

    uploadFile(data) {
      console.log(data)
      data.id = Date.now() + this.tempIndex++
      this.uploadid = data.id
      let formData = new FormData()
      formData.append('file', data, data.name)
      formData.append('uploadId', data.id)
      const request = { ...apis.COMPONENT.FORM_UPLOAD_CONFIG_API }
      request.params = formData
      const that = this
      return new Promise((resolve, reject) => {
        that.$upload(request)
          .asyncThen(
            (resp) => {
              resolve(resp)
              console.log(resp)
            },
            (err) => {
              reject(err)
            }
          )
          .asyncErrorCatch((err) => {
            reject(err)
          })
      })
    },
    handleDeleteFileClick(item) {
      const index = this.attachments.findIndex((att) => att.id === item.id)
      if (index >= 0) {
        this.attachments.splice(index, 1)
      }
      this.checkAttachmentUpload(true)
    }
  }
}
</script>
<style lang="scss" scoped>
.record-comment-input {
  display: -webkit-box; // 兼容 safari
    &:empty::before {
      content: attr(placeholder);
      font-size: 12px;
      color: $--app-notice-color;
      line-height: 36px;
      padding-left: 16px;
    }
  .comment-real-input {
    min-height: 120px;
    border-radius: 2px;
    /*flex: 1 0;*/
    width: 100%;
    outline: none;
    padding: 12px 0 12px 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .text-area-input {
      overflow: hidden auto;
      word-break: break-all;
      word-wrap: break-word;
      cursor: text;
      flex: 1 0 58px;
      font-size: 12px;
      min-height: unset;
      /*padding-right: 16px;*/
      width: 100%;
    }
    .record-comment-attachments {
      .record-comment-attachment {
        display: flex;
        padding: 0 6px;
        align-items: center;
        color: $--app-notice-color;
        margin-right: 12px;
        &:hover {
          background-color: $--app-hover-color;
          border-radius: 4px;
        }
        & + .record-comment-attachment {
          margin-top: 5px;
        }
        .cube-button.cube-button--default {
          height: 12px;
          border: none;
          padding: 0 !important;
          margin-right: 6px;
        }
        .comment-attachment-name {
          font-size: 12px;
          margin-left: 6px;
          flex: 1 0;
          max-width: 85%;
        }
      }
      .record-comment-attachment-error {
        color: red !important;
      }
    }
    .comment-operations {
      display: flex;
      justify-content: space-between;
      margin-top: 12px;
      padding-right: 12px;
      .comment-more-content {
        display: flex;
        .x-uploader-input {
          display: none;
        }
        .upload-demo {
          width: 0.1rem;
          height: 24px;
        }
        .comment-attachment {
          color: $--app-notice-color;
        }
        .comment-select-person {
          margin-left: 12px;
          color: $--app-notice-color;
        }
      }
      .comment-about-input {
        display: flex;
        align-items: center;
        .input-counter {
          font-size: 14px;
          color: $--app-notice-color;
          margin-right: 12px;
        }
      }
    }
  }
  .current-commentor {
    margin-left: 12px;
    height: 36px;
    width: 36px;
  }
}
</style>

<style lang="scss">
.record-comment-input {
  .comment-real-input {
    .text-area-input {
      height: 100%;
      .ProseMirror {
        height: 100%;
        line-height: 1.5;
        outline: none;
        .is-empty.is-editor-empty::before {
          content: attr(data-empty-text);
          font-size: 12px;
          color: $--app-notice-color;
          float: left;
          pointer-events: none;
          height: 0;
        }
        .editor-comment-mention {
          color: $--app-primary-color;
        }
      }
    }
    .record-comment-attachments {
      .record-comment-attachment {
        .cube-btn {
          background-color: transparent;
        }
        .comment-attachment-logo {
          .svg-icon {
            width: 16px !important;
            height: 16px !important;
          }
        }
        .comment-attachment-close {
          cursor: pointer;
          .svg-icon {
            width: 14px !important;
            height: 14px !important;
          }
        }
      }
    }
    .comment-operations {
      .comment-about-input {
        .send-button {
          width: 64px;
          height: 32px;
          border-radius: 2px;
          font-size: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 !important;
          background: $--app-primary-color;
          .el-icon-loading {
            margin-left: 6px;
          }
        }
      }
    }
  }
}
</style>
